import {
  Box,
  Grid2,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Layout from "../../layouts/Layout";
import CustomTabs from "../../Components/Common/CustomTabs";
import CategoryFilters from "../../Components/HomePage/CategoryFilters";
import { filterData, filterData2 } from "../../assets/data";
import HeadingWithBtns from "../../Components/Common/HeadingWithBtns";
import { useDispatch, useSelector } from "react-redux";
import { clearPosts, getAllPosts } from "../../redux/actions/posts.dispatcher";
import SingleVideo from "../../Components/HomePage/SingleVideo";
import SubscribeVideoDrawer from "../../Components/Common/SubscribeVideoDrawer";
import { ConfirmationSnackbar } from "../../Components/Common/CustomSnackbar";
import CategoryFiltersDrawer from "../../Components/Filters/CategoryFiltersDrawer";
import { colors } from "../../theme/theme";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const HomePage = () => {
  const [filter, setFilter] = useState("trending");
  const [contentFilter, setContentFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const { userData } = useSelector((state) => state.user);
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [calendarComponentState, setCalenderComponentState] = useState(false);
  const [tabs, setTabs] = useState("Subscribed Content");

  const handleChange = (event, newValue) => {
    setTabs(newValue);
  };

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const { allPosts, totalPosts, totalPages, currentPage } = useSelector(
    (state) => state.posts
  );

  const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);
  const videoRefs = useRef([]);

  const handlePlayPause = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
      }
    });

    if (currentPlayingIndex === index) {
      videoRefs.current[index].pause();
      setCurrentPlayingIndex(null);
    } else {
      videoRefs.current[index].play();
      setCurrentPlayingIndex(index);
    }
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (!loading) {
      setLoading(true);
      dispatch(getAllPosts(page)).finally(() => setLoading(false));
    }
  }, [page, totalPages]);

  const loadMore = () => {
    if (page < totalPages) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const handleScroll = (event) => {
    const bottom =
      event.target.scrollHeight ===
      event.target.scrollTop + event.target.clientHeight;
    if (bottom && page < totalPages) {
      loadMore();
    }
  };

  const [drawerState, setDrawerState] = useState(false);
  const [paidVideoData, setPaidVideoData] = useState({});
  const [success, setSuccess] = useState(false);

  return (
    <Elements stripe={stripePromise}>
      <Layout>
        {/* <HeadingWithBtns
        creator
        setCalenderComponentState={setCalenderComponentState}
      /> */}

        {/* <Stack
        direction={"row"}
        sx={{
          mt: 4,
          justifyContent: smallScreen ? "center" : "space-between",
        }}
      >
        <CustomTabs
          data={filterData}
          value={filter}
          setValue={setFilter}
          fullScreen={smallScreen}
        />
        {!smallScreen && (
          <CustomTabs
            data={filterData2}
            value={contentFilter}
            setValue={setContentFilter}
          />
        )}
      </Stack> */}

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            mt: 0,
            mb: 0,
            minHeight: "40vh",
          }}
          className="step-1-1 step-6"
          onScroll={handleScroll}
        >
          {/* Sidebar */}
          {/* {!smallScreen && (
          <CategoryFilters
            value={categoryFilter}
            setValue={setCategoryFilter}
          />
        )} */}

          {/* Main Content */}
          {/* {smallScreen && (
          <Box sx={{ width: "100%", overflow: "hidden" }}>
            <Tabs
              value={tabs}
              onChange={handleChange}
              textColor="inherit"
              indicatorColor="#FC0108"
              aria-label="secondary tabs example"
              sx={{
                width: "100%", // Prevents overflow
                display: "flex",
                justifyContent: "center",
                "& .MuiTab-root": {
                  fontSize: "12px",
                  flex: 1, // Makes tabs equal width
                  maxWidth: "50%", // Restricts each tab to 50% width
                  borderBottom: "2px solid #000", // Black border for unselected tabs
                  opacity: 1,
                },
                "& .Mui-selected": {
                  color: "#FC0108", // Selected tab text color
                  borderBottom: "2px solid #FC0108 !important", // Red border for selected tab
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "#FC0108", // Red indicator color
                },
              }}
            >
              <Tab
                sx={{
                  px: 1,
                }}
                value="Subscribed Content"
                label="Subscribed Content"
              />
              <Tab
                sx={{
                  px: 1,
                }}
                value="Free Content"
                label="Free Content"
              />
            </Tabs>
          </Box>
        )} */}

          {smallScreen ? (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                my: 2,
              }}
            >
              {allPosts && allPosts.length === 0 ? (
                <Grid2 item xs={12} sm={6} md={4} lg={3}>
                  <Box
                    sx={{
                      padding: 2,
                      width: "100%",
                      height: "200px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 2,
                    }}
                  >
                    <img
                      src={require("../../assets/icons/no-results.png")}
                      style={{ height: "50px", width: "50px" }}
                      alt="no-content"
                    />
                    <Typography
                      sx={{
                        fontFamily: "Inter-SemiBold",
                        fontSize: "24px",
                        fontWeight: "600",
                        textAlign: "center",
                      }}
                    >
                      You haven't subscribed to any creators.
                    </Typography>
                  </Box>
                </Grid2>
              ) : (
                allPosts?.map((item, index) => (
                  <SingleVideo
                    key={index}
                    item={item}
                    videoRef={(ref) => (videoRefs.current[index] = ref)}
                    onPlayPause={() => handlePlayPause(index)}
                    isPlaying={currentPlayingIndex === index}
                    setDrawerState={setDrawerState}
                    paid={userData.subscribed.some(
                      (i) => i.creatorId === item.creator.id
                    )}
                    setPaidVideoData={setPaidVideoData}
                    page={page}
                  />
                ))
              )}
            </Box>
          ) : (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {allPosts &&
                allPosts
                  ?.filter((val) => {
                    const isContentFiltered =
                      contentFilter === "free"
                        ? val?.visibility === "free"
                        : contentFilter === "subscribed"
                        ? val?.visibility === "paid"
                        : true;

                    const isCategoryFiltered = categoryFilter
                      ? val?.category === categoryFilter
                      : true;

                    return isContentFiltered && isCategoryFiltered;
                  })
                  ?.map((item, index) => (
                    <SingleVideo
                      key={index}
                      item={item}
                      videoRef={(ref) => (videoRefs.current[index] = ref)}
                      onPlayPause={() => handlePlayPause(index)}
                      isPlaying={currentPlayingIndex === index}
                      setDrawerState={setDrawerState}
                      paid={userData.subscribed.some(
                        (i) => i.creatorId === item.creator.id
                      )}
                      setPaidVideoData={setPaidVideoData}
                    />
                  ))}
            </Box>
          )}
          <SubscribeVideoDrawer
            drawerState={drawerState}
            setDrawerState={setDrawerState}
            paidVideoData={paidVideoData}
            setSuccess={setSuccess}
            type="video"
          />

          {/* Snackbar */}
          <ConfirmationSnackbar
            snackbarState={success}
            handleSnackbarClose={() => setSuccess(false)}
            text={"You have subscribed to this content successfully!"}
          />
        </Box>
        <CategoryFiltersDrawer
          drawerState={calendarComponentState}
          setDrawerState={setCalenderComponentState}
          creatorId={1}
          value={categoryFilter}
          setValue={setCategoryFilter}
          type="video"
        />
      </Layout>
    </Elements>
  );
};

export default HomePage;
